export default "__VITE_ASSET__VA1$$Nnc__"